import Nav from './Component/Nav';
import Main from './Component/Main';
import ShowProject from './Component/ShowProject';
import Footer from './Component/Footer';

function App() {
  return (
    <div className="App">
      <Nav />
      <Main />
      <ShowProject />
      <Footer />
    </div>
  );
}

export default App;
